import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from './paginas/not-found/not-found.component';
import { IconsComponent } from './paginas/icons/icons.component';
import { MapsComponent } from './paginas/maps/maps.component';
import { NotificationsComponent } from './paginas/notifications/notifications.component';
import { TypographyComponent } from './paginas/typography/typography.component';
import { UpgradeComponent } from './paginas/upgrade/upgrade.component';
import { HomeComponent } from './paginas/home/home.component';
import { authGuard } from './comum/auth.guard';
import { planoAtivoGuard } from './comum/plano-ativo.guard';
import { logadoGuard } from './comum/logado.fn-guard';
import { landingGuard } from './comum/landing.guard';
import { LandingComponent } from './paginas/landing/landing.component';
import { LandingV2Component } from './paginas/landing-v2/landing-v2.component';
import { RegistroComponent } from './paginas/registro/registro.component';
import { AssinaturaComponent } from './paginas/assinatura/assinatura.component';

const ROUTES: Routes = [
  { path: '', component: LandingV2Component, canActivate: [landingGuard], pathMatch: 'full' },
  {
    path: 'registro', component: RegistroComponent, canActivate: [logadoGuard]
  },
  {
    path: 'assinatura', component: AssinaturaComponent, canActivate: [authGuard]
  },
  {
    path: 'login', canActivate: [logadoGuard], loadChildren: () =>
      import('./paginas/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'recuperar-senha', canActivate: [logadoGuard], loadChildren: () =>
      import('./paginas/recuperar-senha/recuperar-senha.module').then(m => m.RecuperarSenhaModule)
  },
  {
    path: 'painel', canActivate: [planoAtivoGuard], component: HomeComponent, children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard', canActivate: [authGuard],
        loadChildren: () => import('./paginas/dashboard/dashboard.module').then(m => m.DashboardComponentModule)
      },
      {
        path: 'clientes', canActivate: [authGuard], loadChildren: () =>
          import('./paginas/clientes/clientes.module').then(m => m.ClientesComponentModule)
      },
      {
        path: 'servicos', canActivate: [authGuard], loadChildren: () =>
          import('./paginas/servicos/servicos.module').then(m => m.ServicosModule)
      },
      {
        path: 'clinicas', canActivate: [authGuard], loadChildren: () =>
          import('./paginas/clinicas/clinicas.module').then(m => m.ClinicasModule)
      },
      {
        path: 'userprofile', canActivate: [authGuard], loadChildren: () =>
          import('./paginas/user-profile/user-profile.module').then(m => m.UserProfileComponentModule)
      },
      {
        path: 'atendimentos', canActivate: [authGuard], loadChildren: () =>
          import('./paginas/atendimentos/atendimentos.module').then(m => m.AtendimentosModule)
      },
      {
        path: `calendario`, canActivate: [authGuard], loadChildren: () =>
          import('./paginas/calendario/calendario.module').then(m => m.CalendarioComponentModule)
      },
      {
        path: `financeiro`, canActivate: [authGuard], loadChildren: () =>
          import('./paginas/financeiro/financeiro.module').then(m => m.FinanceiroModule)
      },
      {
        path: 'notificacoes', canActivate: [authGuard], loadChildren: () =>
          import('./paginas/notificacoes/notificacoes.module').then(m => m.NotificacoesModule)
      },
      {
        path: 'lembretes', canActivate: [authGuard], loadChildren: () =>
          import('./paginas/lembretes/lembretes.module').then(m => m.LembretesModule)
      },
      {
        path: 'acompanhamento-entre-sessoes', canActivate: [authGuard], loadChildren: () =>
          import('./paginas/acompanhamento-entre-sessoes/acompanhamento-entre-sessoes.module')
            .then(m => m.AcompanhamentoEntreSessoesModule)
      },
      {
        path: 'prontuario', canActivate: [authGuard], loadChildren: () =>
          import('./paginas/prontuario/prontuario.module').then(m => m.ProntuarioModule)
      },
      {
        path: 'formularios', canActivate: [authGuard], loadChildren: () =>
          import('./paginas/formularios/formularios.module').then(m => m.FormulariosModule)
      },
      {
        path: 'perfil-publico', canActivate: [authGuard], loadChildren: () =>
          import('./paginas/perfil-publico/perfil-publico.module').then(m => m.PerfilPublicoModule)
      },
      {
        path: 'captacao', canActivate: [authGuard], loadChildren: () =>
          import('./paginas/captacao/captacao.module').then(m => m.CaptacaoModule)
      },
      {
        path: 'cadastro-online', canActivate: [authGuard], loadChildren: () =>
          import('./paginas/cadastro-online/cadastro-online.module').then(m => m.CadastroOnlineModule)
      },
      {
        path: '', children: [{ path: 'icons', component: IconsComponent }]
      },
      {
        path: '', children: [{ path: 'notifications', component: NotificationsComponent }]
      },
      {
        path: '', children: [{ path: 'maps', component: MapsComponent }]
      },
      {
        path: '', children: [{ path: 'typography', component: TypographyComponent }]
      },
      {
        path: '', children: [{ path: 'upgrade', component: UpgradeComponent }]
      },
    ],
  },
  {
    path: 'perfil', loadChildren: () =>
      import('./paginas/pagina-publica/pagina-publica.module').then(m => m.PaginaPublicaModule)
  },
  {
    path: 'cadastro-online', loadChildren: () =>
      import('./paginas/cadastro-online-publico/cadastro-online-publico.module').then(m => m.CadastroOnlinePublicoModule)
  },
  {
    // Página pública (sem autenticação) — URL da política de privacidade exigida pela Google Play.
    path: 'privacidade-paciente', loadComponent: () =>
      import('./paginas/privacidade/privacidade.component').then(m => m.PrivacidadeComponent)
  },
  {
    // Página pública (sem autenticação) — Termos de Uso do app Easy Paciente.
    path: 'termos-paciente', loadComponent: () =>
      import('./paginas/termos/termos.component').then(m => m.TermosComponent)
  },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(ROUTES)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
